// #VITE_API_URL=http://localhost:7001/vpm-23832/us-central1/portal

const VPM_API_URL = import.meta.env.VITE_API_URL;
const GOOGLE_RECAPTCHA_SITE_KEY = import.meta.env
  .VITE_GOOGLE_RECAPTCHA_SITE_KEY;
const NODE_ENV = import.meta.env.VITE_NODE_ENV;
const FIREBASE_CONNECT_EMULATOR = import.meta.env
  .VITE_FIREBASE_CONNECT_EMULATOR;
const CREATE_DUMMY_INITIAL =
  import.meta.env.VITE_CREATE_DUMMY_INITIAL === "true";

const MAX_UPLOAD_SIZE = parseInt(import.meta.env.VITE_MAX_UPLOAD_SIZE);
const MIN_PATIENT_AGE = parseInt(import.meta.env.VITE_MIN_PATIENT_AGE);
const MAX_PATIENT_AGE = parseInt(import.meta.env.VITE_MAX_PATIENT_AGE);

const ENABLE_LOGGING = import.meta.env.VITE_ENABLE_LOGGING === "true";
const DEBUG_LOGGING = import.meta.env.VITE_DEBUG_LOGGING === "true";
const TRACE_LOGGING = import.meta.env.VITE_TRACE_LOGGING === "true";

const OHS_WEBSITE = import.meta.env.VITE_OHS_WEBSITE;
const PATIENT_REDIRECT = `${OHS_WEBSITE}/${
  import.meta.env.VITE_PATIENT_REDIRECT
}`;
const PROVIDER_REDIRECT = `${OHS_WEBSITE}/${
  import.meta.env.VITE_PROVIDER_REDIRECT
}`;
const OHS_CONSENT = `${OHS_WEBSITE}/${import.meta.env.VITE_OHS_CONSENT}`;
const OHS_TERMS_AND_CONDITIONS = `${OHS_WEBSITE}/${
  import.meta.env.VITE_OHS_TERMS_AND_CONDITIONS
}`;

const FIREBASE_API_KEY = import.meta.env.VITE_FIREBASE_API_KEY || "";
const FIREBASE_AUTH_DOMAIN = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "";
const FIREBASE_PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID || "";
const FIREBASE_STORAGE_BUCKET =
  import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "";
const FIREBASE_MESSENGER_SENDER_ID =
  import.meta.env.VITE_FIREBASE_MESSENGER_SENDER_ID || "";
const FIREBASE_APP_ID = import.meta.env.VITE_FIREBASE_APP_ID || "";
const FIREBASE_MEASUREMENT_ID =
  import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "";

const ENABLE_FIREBASE_PERF = import.meta.env.VITE_ENABLE_FIREBASE_PERF === "true";

export const config = {
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSENGER_SENDER_ID,
  FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID,
  VPM_API_URL,
  GOOGLE_RECAPTCHA_SITE_KEY,
  NODE_ENV,
  FIREBASE_CONNECT_EMULATOR,
  CREATE_DUMMY_INITIAL,
  MAX_UPLOAD_SIZE,
  MIN_PATIENT_AGE,
  MAX_PATIENT_AGE,
  ENABLE_LOGGING,
  DEBUG_LOGGING,
  TRACE_LOGGING,
  PATIENT_REDIRECT,
  PROVIDER_REDIRECT,
  OHS_WEBSITE,
  OHS_CONSENT,
  OHS_TERMS_AND_CONDITIONS,
  ENABLE_FIREBASE_PERF
};

//console.log("*****CONFIG", config);
console.log("*****VITE_API_URL", import.meta.env.VITE_API_URL);
console.log("*****VITE_NODE_ENV", import.meta.env.VITE_NODE_ENV);
console.log("*****VITE_ENABLE_LOGGING", import.meta.env.VITE_ENABLE_LOGGING);
